import NeuroMixer from "./NeuroMixer";

export default NeuroMixer;